export default __webpack_public_path__ + "static/media/pflastern-2.b0089764.jpeg";